import React from 'react';
import { formatDateTime } from './formatDateTime';

export const formatMessageDates = (msg?: string | null): React.ReactNode => {
    const text = msg || '';
    const isoRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?/g;
    let lastIndex = 0;
    const nodes: Array<React.ReactNode> = [];
    let m: RegExpExecArray | null;
    while ((m = isoRegex.exec(text)) !== null) {
        const idx = m.index;
        if (idx > lastIndex) {nodes.push(text.slice(lastIndex, idx));}
        const matched = m[0];
        let formatted = matched;
        try {
            formatted = formatDateTime(matched);
        } catch (e) {
            console.info('Date formatting failed:', e);
            formatted = matched;
        }
        nodes.push(<span key={idx} className="formatted-date">{formatted}</span>);
        lastIndex = idx + matched.length;
    }
    if (lastIndex < text.length) {nodes.push(text.slice(lastIndex));}
    if (nodes.length === 0) {return text;}
    return <>{nodes}</>;
};

export default formatMessageDates;
